import { createActions } from 'redux-actions';

export const {
  // GET BUTTONS BY PROFILE
  getProfileButtons,
  getProfileButtonsSuccess,
  getProfileButtonsFailure,
} = createActions(
  'GET_PROFILE_BUTTONS',
  'GET_PROFILE_BUTTONS_SUCCESS',
  'GET_PROFILE_BUTTONS_FAILURE'
);
